module.exports = __webpack_public_path__ + "img/c13.bbe919e0.png";